"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.opacities = void 0;
var opacities_1 = __importDefault(require("../tokens/opacities"));
exports.opacities = opacities_1.default;
//# sourceMappingURL=opacities.js.map